
export const responsive = {
    extrasuperLargeDesktop: { breakpoint: { max: 4000, min:2000  }, items: 5,slidesToSlide: 3  },
    superLargeDesktop: { breakpoint: { max: 2000, min: 1600 }, items: 4,slidesToSlide: 3  },
    desktop: { breakpoint: { max: 1600, min: 1024 }, items: 3,slidesToSlide: 3 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2,slidesToSlide: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
  };